import { useMutation } from '@apollo/client'
import { EditCompanyMember, EditCompanyMemberVariables } from '../../types'
import { EDIT_COMPANY_MEMBER } from './operations'

export const useEditCompanyMember = () =>
  useMutation<EditCompanyMember, EditCompanyMemberVariables>(EDIT_COMPANY_MEMBER)
